import { render, staticRenderFns } from "./GuppyChatSidebarFooter.vue?vue&type=template&id=bd5de21c&scoped=true"
import script from "./GuppyChatSidebarFooter.vue?vue&type=script&lang=js"
export * from "./GuppyChatSidebarFooter.vue?vue&type=script&lang=js"
import style0 from "./GuppyChatSidebarFooter.vue?vue&type=style&index=0&id=bd5de21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5de21c",
  null
  
)

export default component.exports